import { useState } from "react";
import {
  Box,
  TextField,
  Typography,
  Button,
  useTheme,
} from "@mui/material";
import { useTranslation } from "react-i18next";
import AppBackground from "../components/layout/AppBackground";

const ForgotPassword = () => {
  const theme = useTheme();
  const { t } = useTranslation("forgot");
  const [email, setEmail] = useState("");
  const [submitted, setSubmitted] = useState(false);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");

    if (!/.+@.+\..+/.test(email)) {
      setError(t("invalid_email"));
      return;
    }

    setLoading(true);
    try {
      const res = await fetch(`${process.env.REACT_APP_API_URL}/auth/forgot-password`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email, language: t("lang") }),
      });

      if (res.ok) {
        setSubmitted(true);
      } else {
        const data = await res.json();
        setError(data.msg || t("error"));
      }
    } catch {
      setError(t("network_error"));
    } finally {
      setLoading(false);
    }
  };

  return (
    <AppBackground
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <Box
        component="form"
        onSubmit={handleSubmit}
        sx={{
          backgroundColor: "#212121",
          color: "#fff",
          borderRadius: 4,
          p: 4,
          maxWidth: 400,
          width: "100%",
          textAlign: "center",
          boxShadow: "0 0 20px rgba(0,0,0,0.5)",
        }}
      >
        <img
          src="/assets/logo-icon.png"
          alt="Pitchest Logo"
          style={{ height: 80, marginBottom: 16 }}
        />
        <Typography variant="h5" gutterBottom>
          {t("title")}
        </Typography>

        {submitted ? (
          <Typography sx={{ mt: 3 }}>{t("check_email")}</Typography>
        ) : (
          <>
            <TextField
              label={t("email")}
              type="email"
              fullWidth
              margin="normal"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              InputLabelProps={{ shrink: true }}
              sx={{ mt: 1, mb: 1 }}
            />
            {error && (
              <Typography color="error" variant="body2" sx={{ mt: 1 }}>
                {error}
              </Typography>
            )}
            <Button
              type="submit"
              variant="contained"
              fullWidth
              sx={{ mt: 2, borderRadius: 999, py: 1.2 }}
              disabled={loading}
            >
              {loading ? t("sending") : t("submit")}
            </Button>
          </>
        )}
      </Box>
    </AppBackground>
  );
};

export default ForgotPassword;
